import Chart = require("chart.js");
import {ChartElement} from "../model/ChartElement";
import {ChartData} from "chart.js";
import {Moment} from "moment";

export type DrawableLine = Array<string | string[] | number | number[] | Date | Date[] | Moment | Moment[]>;

export class DrawChartService {
    static instance = [
        DrawChartService
    ];

    drawLineChart = (ctx: CanvasRenderingContext2D,
                     data: ChartData,
                     title: string,
                     clickCallback?: (event?: MouseEvent, activeElements?: Array<ChartElement>) => any): Chart =>
        new Chart(ctx, {
            type: 'line',
            data: data,
            options: {
                elements: {
                    line: {
                        tension: 0.1
                    }
                },
                responsive: true,
                maintainAspectRatio: false,
                onClick: clickCallback,
                title: {
                    display: true,
                    text: title
                }
            }
        });

    drawStackedBarGraph = (ctx: CanvasRenderingContext2D,
                           title : string,
                           data: ChartData): Chart =>
        new Chart(ctx, {
            type: 'bar',
            data: data,
            options: {
                responsive: true,
                maintainAspectRatio: false,
                title: {
                    display: true,
                    text: title
                },
                tooltips: {
                    mode: 'index',
                    intersect: false
                },
                scales: {
                    xAxes: [{
                        stacked: true,
                    }],
                    yAxes: [{
                        stacked: true
                    }]
                }
            }
        })


}